module.exports = __webpack_public_path__ + "media/images/sampleBet__deco-ad350dc864b7ad96fc98ecb9323d061d.png";